// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__32ElW","fileDisabled":"File_fileDisabled__3Boza"};